import { useState, useCallback } from "react";
import useLocalStorage from "./storage.js";

export default function usePersistedToggle(key){
  const [defaultOpen, setDefaultOpen] = useLocalStorage(key, true);
  const [open, _setOpen] = useState(defaultOpen);
  const toggle = useCallback(() => {
    const nowOpen = !open;
    if(!nowOpen){
      setDefaultOpen(false);
    }
    _setOpen(nowOpen);
  }, [open, _setOpen, setDefaultOpen]);
  return [open, toggle];
}
